import { InventoryItem } from "@/components/Types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ScreenInfo {
    path: string;
    title: string;
}

export interface NavState {
    screenInfo: ScreenInfo | null;
}

const initialState: NavState = {    
    screenInfo: null,
}

export const navSlice = createSlice({
    name: 'nav',
    initialState,
    reducers: {
        setScreenInfo: (state, action: PayloadAction<ScreenInfo>) => {
            state.screenInfo = action.payload;
        }
    }
});

export const { setScreenInfo } = navSlice.actions;
export default navSlice.reducer;